import { STATUS, statusActions } from "@/constant/statusConstants";
import IconButton from "..";
import { CheckIcon, RestrictUserIcon } from "@/constant/imagePath";

const statusActionMap = statusActions();

const ChangeStatusButton = ({
  isActive = STATUS.INACTIVE,
  icon = !isActive ? CheckIcon : RestrictUserIcon,
  borderColor = !isActive ? "#05A16D" : "#C96500",
  fromColor = !isActive ? "#19C38B" : "#E7A000",
  toColor = !isActive ? "#088D96" : "#C96500",
  buttonStyle = { padding: "3.3px 2.5px" },
  onClick = null,
  tooltipText = !isActive
    ? statusActionMap[STATUS.ACTIVE]
    : statusActionMap[STATUS.INACTIVE],
  ...props
}) => {
  return (
    <IconButton
      icon={icon}
      borderColor={borderColor}
      fromColor={fromColor}
      toColor={toColor}
      buttonStyle={buttonStyle}
      onClick={onClick}
      tooltipText={tooltipText}
      {...props}
    />
  );
};

export default ChangeStatusButton;
